import React from 'react';
import cx from 'classnames';
import PropTypes from 'prop-types';
import { Amex, ApplePay, GooglePay, Mastercard, PODERcardGradient, Visa } from '@separate/icons';
import styles from './paymentMethodInfoCard.module.scss';

export default function WalletInfoCard({ primary, wallet }) {
  const defaultCardIcon = () => {
    return (
      <div className={styles.defaultIcon}>
        <PODERcardGradient />
      </div>
    );
  };

  const walletMapping = {
    amex_express_checkout: {
      name: 'Amex Express Checkout',
      icon: Amex,
    },
    apple_pay: {
      name: 'Apple Pay',
      icon: ApplePay,
    },
    google_pay: {
      name: 'Google Pay',
      icon: GooglePay,
    },
    masterpass: {
      name: 'Masterpass',
      icon: Mastercard,
    },
    samsung_pay: {
      name: 'Samsung Pay',
      icon: defaultCardIcon,
    },
    visa_checkout: {
      name: 'Visa Checkout',
      icon: Visa,
    },
  };

  const walletType = walletMapping[wallet.type];
  const WalletIcon = walletType.icon;

  return (
    <div className={cx(styles.infoCard, { [styles.primary]: primary })}>
      <WalletIcon className={styles.cardIcon} />
      <div className={styles.wallet}>
        {`${walletType.name}`}
      </div>
    </div>
  );
}

WalletInfoCard.propTypes = {
  primary: PropTypes.bool,
  wallet: PropTypes.object.isRequired,
};
